<template>
  <a-form-model ref='form' :model='model' :rules='validatorRules'>
    <a-form-model-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='映射更新表单' prop='title' required>
      <a-select v-model='model.title' placeholder='请选择表单' >
        <a-select-option value='test'>测试选项</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='映射更新元素' prop='content' required>
      <a-select v-model='model.content' placeholder='请选择元素' >
        <a-select-option value='test'>测试选项</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='数据来源项目' prop='content2' required>
      <a-select v-model='model.content2' placeholder='请选择数据来源项目' >
        <!--<a-select-option value='test'>测试选项</a-select-option>-->
      </a-select>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'Step1',
  props: ['model'],
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      validatorRules: {},
    }
  },
  created() {
  },
  methods: {
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.form.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>
